import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
const DPSubjectsSetup = store => ({
  path: "dpSubjects",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "school-onboard-setup" */ "./components"),
        import(
          /* webpackChunkName: "school-onboard-setup" */ "DPSubjectsSetup/modules/DPSetupSubjectsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const dpSubjectSetupReducer = importedModule1.default;
        injectReducer(store, {
          key: "dpSubjectsSetup",
          reducer: dpSubjectSetupReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
export default DPSubjectsSetup;
